import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const billingHistoryPageReducer = (state = initialState.billingHistoryPage, action) => {
  switch (action.type) {
    case actionTypes.billingHistoryPage.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default billingHistoryPageReducer;
